import React from 'react';
import { Link } from 'react-router-dom';

export default class GettingStarted extends React.Component {
  render() {
    return (
      <div className='getting-started'>
        <div className='intro'>
          <h4>No tacks yet? Get started.</h4>
          <p className='item-meta'>A "tack" is the process of using spaced repetition to remember a word.</p>
        </div>
        <ol>
          <li>
            <Link to='/account/recommend_people_to_follow'>Follow one or two people</Link> to discover words they're tacking.
          </li>
          <li>
            Tack one of our <Link to='/tacks/trends/most_tacked'>most popular words this month</Link>.
          </li>
          <li>
            <b>Learning English</b>? Tack the definition of a word in your native language. <Link to='/words/house/ru'>Here's the definition of "house" in Russian</Link>, for example.
          </li>
          <li>
            Or, <Link to='/'>search for any word you can think of</Link>.
          </li>
        </ol>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/getting_started.jsx